import React, { useState, useEffect } from 'react';

import { useMyContext, useAssets } from 'hooks'
import { MobileFooter } from 'components';
import { Wrapper, LeftContainer, RightContainer, StyledText, StyledSpan, StyledSelect, PeriodList, PeriodItem } from './styles'

const Period = ({selectedPeriod, periods, setSelectedPeriod, selectedTab}) => {
  const { t } = useMyContext();
  const [ isOpenModal, setIsOpenModal ] = useState();
  const { assets, generatePeriodString } = useAssets();
  const [ periodString, setPeriodString ] = useState(t['period:calc']);

  useEffect(() => {
    setPeriodString(generatePeriodString(selectedTab));
  }, [selectedPeriod, assets]);

  const handleMouseDown = (event) => {
    event.preventDefault();
    setIsOpenModal(true);
  }

  const handlePeriodClick = (period) => {
    setIsOpenModal(false);
    setSelectedPeriod(period);
  }

  return (
    <>
      <Wrapper>
        <LeftContainer>
          <StyledText bold>{t['molecules:ThirdHeader:periodo']}</StyledText>
          <StyledSpan>{periodString}</StyledSpan>
        </LeftContainer>
        <RightContainer>
          <StyledSelect defaultValue={0} onMouseDown={handleMouseDown}>
            <option disabled={true} value={0}>{t[`period:${selectedPeriod}`]}</option>
          </StyledSelect>
        </RightContainer>
      </Wrapper>
      <MobileFooter 
        body={
          <PeriodList>
            {!!periods && periods.map(period => (
              <PeriodItem key={period} onClick={() => handlePeriodClick(period)}>{t[`period:${period}`]}</PeriodItem>
            ))}
          </PeriodList>
        }
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
      />
    </>
  )
}

export default Period;